import { orderBy } from "lodash";
export function getRoleFromName(roles: any[], roleName: string): any {

  if (!roles)
    return null;
  if (!roleName)
    return null;

  let role = roleName.trim();

  if (role) {
    let r = roles.map(x => x["data"]).firstOrDefault(x => x && x.name == role);
    return r;
  }
  return null;
}
declare global {
  interface Array<T> {
    firstOrDefault(condition: (item: T) => boolean, defaultValue:any): T;
    firstOrDefault(condition: (item: T) => boolean): T;
    where(condition: (item: T) => boolean): T[];
    orderBy(property: string, order: (null| 'asc' | 'desc')): T[];
  }
}

Array.prototype.firstOrDefault = function (condition: (item: any) => boolean, defaultValue=null) {
  var items = this;
  if (!items)
    return defaultValue;

  for (var i = 0; i < items.length; i++) {
    if (condition(items[i]))
      return items[i];
  }

  return defaultValue;
};

Array.prototype.where  = function (condition: (item: any) => boolean) {
  var items = this;
  if (!items)
    return items;
  let ret = [];
  for (var i = 0; i < items.length; i++) {
    if (condition(items[ i ]))
      ret.push(items[ i ]);
  }

  return ret;

};
Array.prototype.orderBy = function (property:string, order:('asc'|'desc')) {
  var items:any[] = this;
  if (!items)
    return items;

  if (!order)
    return items;

  let ret = orderBy(items, [property], [order]);

  return ret;




};

